"use client";

import { LogIn } from "lucide-react";
import { useLoginGate } from "@/components/login-gate-dialog";

/**
 * AI 助手登录引导(AI 专属文案)。
 * 返回与 useLoginGate 相同的接口,文案预设为 AI 助手场景。
 */
export function useAiLoginGate() {
  return useLoginGate({
    title: "登录后使用 AI 助手",
    description: "登录即可解锁 AI 智能对话、趋势分析等功能",
    icon: <LogIn className="w-5 h-5" />,
  });
}
